import { useState, useEffect } from 'react';

const STORAGE_KEY = 'dashboard_visibility';

export function useDashboardVisibility() {
  const [isVisible, setIsVisible] = useState(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      return saved ? JSON.parse(saved) : true;
    } catch {
      return true;
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(isVisible));
    } catch (error) {
      console.error('Error guardando visibilidad:', error);
    }
  }, [isVisible]);

  const toggleVisibility = () => setIsVisible((prev: any) => !prev);
  const setVisibility = (value: boolean) => setIsVisible(value);

  return { isVisible, toggleVisibility, setVisibility };
}